import { useIntl, type IntlShape } from 'react-intl'

type FormatMessageValues = Parameters<IntlShape['formatMessage']>[1]

export function useFormatMessage() {
	const intl = useIntl()
	/** Safe only for primitive interpolation values. For React element values use intl.formatMessage directly. */
	const t = (id: string, values?: FormatMessageValues): string =>
		intl.formatMessage({ id }, values) as unknown as string
	return { t }
}
